function Message($el) {
    this.$el = $el;
    this.$el.find(".message__close").click(this.close.bind(this));
    this.id = this.$el.data("id");
    this.start = this._getTime(this.$el.data("start"));
    this.end = this._getTime(this.$el.data("end"));
    this.expiry = parseInt(this.$el.data("expiry"));
    this.now = moment();
    if (this.expiry) {
        this.expiry = moment().add(this.expiry, "s")
    }
    this.cookie = "message-" + this.id;
    if (this._expiryMismatch()) {
        this._setCookie()
    }
    if (this._isValid()) {
        this.show()
    } else {
        this._remove()
    }
}
Message.prototype = {
    close: function() {
        this._setCookie();
        this._remove()
    },
    show: function() {
        this.$el.addClass("message--show")
    },
    _remove: function() {
        this.$el.remove();
        this.$el = false
    },
    _getTime: function(str) {
        if (str) {
            var time = moment(str);
            if (moment.isMoment(time)) {
                return time
            }
        }
        return false
    },
    _setCookie: function() {
        var isSession = !moment.isMoment(this.expiry);
        var expiry = isSession ? false : {
            expires: this.expiry.toDate()
        };
        var value = isSession ? this.cookie : this.expiry.toISOString();
        Cookies.set(this.cookie, value, expiry)
    },
    _isValid: function() {
        var valid = true;
        if (this.start && this.now.isBefore(this.start) || this.end && this.now.isAfter(this.end) || Cookies.get(this.cookie)) {
            valid = false
        }
        return valid
    },
    _expiryMismatch: function() {
        var cookie = Cookies.get(this.cookie);
        if (cookie && cookie !== this.cookie) {
            var expiry = moment(cookie);
            if (moment.isMoment(expiry) && expiry.isAfter(this.expiry)) {
                return true
            }
        }
        return false
    }
};
SetDesign(function($, _, window, document) {
    var addFilter = SetDesign.addFilter;
    var $messages = $(".message").filter(function() {
        var message = new Message($(this));
        return message.$el
    });
    if ($messages.length) {
        addFilter("stickyHeader/triggerHeight", function(val) {
            var height = $messages.first().height() || 0;
            height = height ? height + 20 : 0;
            return val + height
        }, 5);
        addFilter("css-vars/register", function(styles) {
            styles["navburger-top"] = function() {
                return "40px"
            };
            return styles
        }, 20)
    }
});